function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { format as formatFn, getHours, getMinutes, getSeconds, isDate, setHours, setMinutes, setSeconds } from 'date-fns';
var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};
export function noop() {}
export function formatDate(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return formatFn(value, format, option);
}
export function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = {};

  if (typeof disabledTime === 'function') {
    disabledTimeConfig = disabledTime(value);
  } else if (disabledTime) {
    disabledTimeConfig = disabledTime;
  }

  disabledTimeConfig = _objectSpread({}, defaultDisabledTime, {}, disabledTimeConfig);
  return disabledTimeConfig;
}
export function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;

  if (value) {
    var hour = getHours(value);
    var minutes = getMinutes(value);
    var seconds = getSeconds(value);
    var disabledHours = disabledTimeConfig.disabledHours();

    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);

      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }

  return !invalidTime;
}
export function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}
export function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }

  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }

  return true;
}
export function isValidArray(arr) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (!arr) {
    return false;
  }

  return Array.isArray(arr) && arr.length === size && arr.every(function (v) {
    return v;
  });
}
export function normalizeDate(value) {
  return isDate(value) ? value : undefined;
}
export function getValidDate(value) {
  var ret = value;

  if (!isDate(ret)) {
    ret = new Date();
  }

  return ret;
} // 时分秒保持同步

export function syncTime(date, time) {
  if (!isDate(date) || !isDate(time)) {
    return date;
  }

  var result = setHours(date, getHours(time));
  result = setMinutes(result, getMinutes(time));
  result = setSeconds(result, getSeconds(time));
  return result;
}
export { isDate };